import { Boxes, CheckCheck, Layers, ListChecks, Sun } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

/**
 * Bottom nav for the Chores app:
 *
 *   [List] [Today] [Batch] [Assets] [Done]
 *
 *   - List    the centralized, urgency-ranked backlog (the home base)
 *   - Today   one-thing-a-day focus (Caloz's "Tomorrow List")
 *   - Batch   group errands by context / time / resistance / manual batch
 *   - Assets  things you maintain + the history of work done on each
 *   - Done    completed history (with undo)
 */
export const choresBottomNav: BottomNavItem[] = [
  { id: 'list', label: 'List', icon: ListChecks, href: '/apps/chores' },
  { id: 'today', label: 'Today', icon: Sun, href: '/apps/chores/today' },
  { id: 'batch', label: 'Batch', icon: Layers, href: '/apps/chores/batch' },
  {
    id: 'assets',
    label: 'Assets',
    icon: Boxes,
    href: '/apps/chores/assets',
    matchPaths: ['/apps/chores/assets'],
  },
  { id: 'done', label: 'Done', icon: CheckCheck, href: '/apps/chores/done' },
]
